import { defineComponent } from 'vue';

export default defineComponent({
  computed: {
    ribbonEnv(): string {
      return this.$store.getters.ribbonOnProfiles;
    },
    ribbonEnabled(): boolean {
      return this.$store.getters.ribbonOnProfiles && this.$store.getters.activeProfiles.indexOf(this.$store.getters.ribbonOnProfiles) > -1;
    },
  },
});
